import { Directive } from '@angular/core';

import { minxinSubscription } from './minxin';



@Directive()
class SubscriptionComponent {
}

export const SubscriptionBase = minxinSubscription(SubscriptionComponent)
